"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var buttons_component_1 = require("../components/buttons.component");
var icons_component_1 = require("../components/icons.component");
/**
 * @react-component GenericResultView - Generic result page for success and error
 *
 * @param props.resultType - { string } 'success' or 'error'
 * @param props.headerContent - { string | Object } - if passed an object with prop `__html` it will
 * `dangerouslySetInnerHTML`, else it will just render the string
 * @param props.bodyContent - { string } - optional - main body of result page
 * @param props.buttonData - { Button } - same properties as Button component
 */
function GenericResultView(_a) {
    var resultType = _a.resultType, headerContent = _a.headerContent, bodyContent = _a.bodyContent, buttonData = _a.buttonData, secondaryLinksData = _a.secondaryLinksData;
    return (React.createElement("div", { className: "generic-container" },
        resultType === "success" ? (React.createElement(icons_component_1.IllustrationComponent, { modifierClass: "successImg", image: "Success" })) : (React.createElement(icons_component_1.default, { icon: "AttentionIcon_large", modifierClass: "generic-icon_error" })),
        headerContent.__html ? (React.createElement("h2", { className: "vx_h2 generic-header", dangerouslySetInnerHTML: headerContent })) : (React.createElement("h2", { className: "vx_h2 generic-header" }, headerContent)),
        bodyContent ? (React.createElement("p", { className: "generic-message" }, bodyContent)) : null,
        React.createElement(buttons_component_1.Button, tslib_1.__assign({}, buttonData, { modifierClass: "vx_btn-block " + (buttonData.modifierClass || "") })),
        secondaryLinksData
            ? secondaryLinksData.map(function (linkData, index) {
                return (React.createElement("a", { href: linkData.href, target: linkData.target || "", key: index, className: "generic-secondaryActions" }, linkData.content));
            })
            : null));
}
exports.default = GenericResultView;
